(() => {
  'use strict';
  const panel = document.querySelector('#sw-saved');
  if (!panel || typeof panel.showModal !== 'function') return;
  const ar = panel.dataset.swsLocale.startsWith('ar');
  const locale = panel.dataset.swsLocale;
  const root = (panel.dataset.swsRoot || '/').replace(/\/$/, '') + '/';
  const words = ar ? {
    save: 'حفظ', saved: 'محفوظ', remove: 'إزالة', empty: 'قائمتك تبدأ باختيار يعجبك.',
    hint: 'اضغط على القلب بجانب أي منتج للاحتفاظ به هنا.', view: 'عرض المنتج والخيارات الحالية',
    added: 'تمت إضافة المنتج إلى قائمتك.', removed: 'تمت إزالة المنتج من قائمتك.',
    cleared: 'تم مسح القائمة.', temporary: 'الحفظ متاح خلال هذه الزيارة فقط لأن تخزين المتصفح غير متاح.',
    limit: 'قائمتك تحتوي على 40 منتجاً. أزل منتجاً لإضافة اختيار جديد.', missing: 'هذا المنتج غير متاح حالياً.',
    label: 'المنتجات المحفوظة'
  } : {
    save: 'Save', saved: 'Saved', remove: 'Remove', empty: 'A few favourites. All in one place.',
    hint: 'Tap the heart on any product to keep it here while you decide.', view: 'View product & current options',
    added: 'Product added to your saved finds.', removed: 'Product removed from your saved finds.',
    cleared: 'Your saved list is clear.', temporary: 'Browser storage is unavailable. Items are saved for this visit only.',
    limit: 'You have 40 saved products. Remove an item to save another.', missing: 'This product is currently unavailable.',
    label: 'Saved items'
  };
  const key = 'switchon-saved-products-v1';
  const list = panel.querySelector('[data-sws-list]');
  const status = document.querySelector('[data-sws-status]');
  const cache = new WeakMap();
  let items = [], storageAvailable = true, opener, renderVersion = 0, frame = 0;
  const valid = item => item && /^\d+$/.test(item.id) && /^[a-z0-9][a-z0-9-]*$/.test(item.handle) && typeof item.title === 'string';
  const read = () => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '[]');
      return Array.isArray(value) ? value.filter(valid).slice(0, 40) : [];
    } catch (_) { return []; }
  };
  items = read();
  function persist() {
    try { localStorage.setItem(key, JSON.stringify(items)); }
    catch (_) { storageAvailable = false; }
  }
  let statusTimer;
  function announce(message) {
    clearTimeout(statusTimer);
    status.textContent = message;
    status.classList.add('is-visible');
    statusTimer = setTimeout(() => { status.classList.remove('is-visible'); }, 4500);
  }
  function data(button) {
    if (!cache.has(button)) {
      try { cache.set(button, JSON.parse(button.dataset.swsProduct)); }
      catch (_) { cache.set(button, null); }
    }
    return cache.get(button);
  }
  function sync() {
    document.querySelectorAll('[data-sws-product]').forEach(button => {
      const item = data(button);
      if (!valid(item)) return;
      button.hidden = false;
      const selected = items.some(saved => saved.id === item.id);
      button.setAttribute('aria-pressed', String(selected));
      const text = selected ? words.saved : words.save;
      button.setAttribute('aria-label', (selected ? words.remove : words.save) + ' ' + item.title);
      const label = button.querySelector('[data-sws-label]');
      if (label && label.textContent !== text) label.textContent = text;
    });
    document.querySelectorAll('[data-sws-open]').forEach(link => {
      link.closest('.wishlist-header')?.classList.remove('hidden');
      link.setAttribute('aria-label', words.label + (items.length ? ' (' + items.length + ')' : ''));
    });
    document.querySelectorAll('[data-sws-count]').forEach(badge => {
      if (badge.textContent !== String(items.length)) badge.textContent = String(items.length);
      badge.hidden = !items.length;
    });
  }
  function element(tag, text, className) {
    const el = document.createElement(tag);
    if (text) el.textContent = text;
    if (className) el.className = className;
    return el;
  }
  function imageURL(value) {
    try {
      const url = new URL(value, location.origin);
      if (url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname === 'cdn.shopify.com')) return url.href;
    } catch (_) {}
    return '';
  }
  function render() {
    const version = ++renderVersion;
    list.replaceChildren();
    panel.querySelector('[data-sws-clear]').hidden = !items.length;
    if (!items.length) {
      const empty = element('div', null, 'sws-empty');
      empty.append(element('span', '♡', 'sws-empty-heart'), element('h3', words.empty), element('p', words.hint));
      list.append(empty);
      return;
    }
    const rows = [];
    items.forEach(item => {
      const row = element('article', null, 'sws-item');
      const link = element('a', null, 'sws-item-image');
      link.href = root + 'products/' + item.handle;
      link.tabIndex = -1;
      link.setAttribute('aria-hidden', 'true');
      const src = imageURL(item.image);
      const img = element('img');
      if (src) { img.src = src; img.alt = ''; img.width = 120; img.height = 120; img.loading = 'lazy'; link.append(img); }
      else link.append(element('span', '◇'));
      const copy = element('div', null, 'sws-item-copy');
      const title = element('a', item.title); title.href = link.href;
      const heading = element('h3'); heading.append(title);
      const view = element('a', words.view, 'sws-view'); view.href = link.href;
      const remove = element('button', words.remove, 'sws-remove');
      remove.type = 'button'; remove.dataset.swsRemove = item.id;
      remove.setAttribute('aria-label', words.remove + ' ' + item.title);
      copy.append(heading, view, remove); row.append(link, copy); list.append(row);
      rows.push({item, title, remove, row, link, img});
    });
    // Fetch the current locale's title only when a shopper opens their saved list.
    // Prices are never stored and purchases continue through the native product page.
    let cursor = 0;
    async function updateTitles() {
      while (cursor < rows.length && version === renderVersion && panel.open) {
        const entry = rows[cursor++];
        try {
          const response = await fetch(root + 'products/' + entry.item.handle + '.js', {headers: {'Accept': 'application/json'}});
          if (version !== renderVersion || !panel.open) return;
          if (response.status === 404) { entry.row.append(element('p', words.missing, 'sws-unavailable')); continue; }
          if (!response.ok) continue;
          const product = await response.json();
          if (version !== renderVersion || !panel.open || String(product.id) !== entry.item.id) continue;
          if (typeof product.title === 'string') {
            entry.title.textContent = product.title;
            entry.remove.setAttribute('aria-label', words.remove + ' ' + product.title);
            const saved = items.find(item => item.id === entry.item.id);
            if (saved) { saved.title = product.title; saved.locale = locale; }
          }
          const src = imageURL(product.featured_image);
          if (src) { entry.img.src = src; entry.img.alt = ''; entry.img.width = 120; entry.img.height = 120; entry.link.replaceChildren(entry.img); }
        } catch (_) { /* Keep the last saved title if the network is unavailable. */ }
      }
      if (version === renderVersion) persist();
    }
    for (let n = 0; n < Math.min(3, rows.length); n++) updateTitles();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sws-product]');
    const open = event.target.closest('[data-sws-open]');
    if (button) {
      event.preventDefault(); event.stopPropagation();
      const item = data(button); if (!valid(item)) return;
      const position = items.findIndex(saved => saved.id === item.id);
      if (position >= 0) items.splice(position, 1);
      else {
        if (items.length >= 40) { announce(words.limit); return; }
        items.unshift({...item});
      }
      persist(); sync(); announce(storageAvailable ? (position >= 0 ? words.removed : words.added) : words.temporary);
    } else if (open) {
      event.preventDefault(); event.stopPropagation();
      opener = open; panel.showModal(); document.documentElement.classList.add('sws-is-open'); render();
    }
  });
  panel.addEventListener('click', event => {
    if (event.target.closest('[data-sws-close]')) panel.close();
    const remove = event.target.closest('[data-sws-remove]');
    if (remove) {
      const index = items.findIndex(item => item.id === remove.dataset.swsRemove);
      if (index >= 0) items.splice(index, 1);
      persist(); render(); sync(); announce(words.removed);
      const buttons = panel.querySelectorAll('[data-sws-remove]');
      (buttons[Math.min(index, buttons.length - 1)] || panel.querySelector('[data-sws-close]')).focus();
    }
    if (event.target.closest('[data-sws-clear]')) {
      items = []; persist(); render(); sync(); announce(words.cleared); panel.querySelector('[data-sws-close]').focus();
    }
    if (event.target === panel) {
      const rect = panel.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) panel.close();
    }
  });
  panel.addEventListener('close', () => { renderVersion++; document.documentElement.classList.remove('sws-is-open'); opener?.focus(); });
  window.addEventListener('storage', event => { if (event.key === key) { items = read(); sync(); if (panel.open) render(); } });
  new MutationObserver(() => {
    if (!frame) frame = requestAnimationFrame(() => { frame = 0; sync(); });
  }).observe(document.querySelector('#root') || document.body, {childList: true, subtree: true});
  sync();
})();
